import React from "react";
import AppConfig from "util/AppConfig";
import ObjectUtils from "util/ObjectUtils";
import { Input } from "components/bootstrap";
import { Select, TimeUnitInput } from "components/common";
const MaxmindAdapterFieldSet = ({
  config,
  updateConfig,
  handleFormEvent,
  validationState,
  validationMessage
}) => {
  const isCloud = AppConfig.isCloud();
  const pathsForCloud = {
    IPINFO_STANDARD_LOCATION: "/etc/graylog/server/standard_location.mmdb",
    IPINFO_ASN: "/etc/graylog/server/asn.mmdb"
  };
  const ipInfoDatabaseTypes = [
    { label: "IPinfo location database", value: "IPINFO_STANDARD_LOCATION" },
    { label: "IPinfo ASN database", value: "IPINFO_ASN" }
  ];
  let databaseTypes = [
    { label: "ASN database", value: "MAXMIND_ASN" },
    { label: "City database", value: "MAXMIND_CITY" },
    { label: "Country database", value: "MAXMIND_COUNTRY" }
  ];
  if (isCloud) {
    databaseTypes = ipInfoDatabaseTypes;
  } else {
    databaseTypes = databaseTypes.concat(ipInfoDatabaseTypes);
  }
  const update = (value, unit, enabled, name) => {
    const newConfig = ObjectUtils.clone(config);
    newConfig[name] = enabled ? value : 0;
    newConfig[`${name}_unit`] = unit;
    updateConfig(newConfig);
  };
  const updateCheckInterval = (value, unit, enabled) => {
    update(value, unit, enabled, "check_interval");
  };
  const onDbTypeSelect = (id) => {
    const newConfig = ObjectUtils.clone(config);
    if (isCloud) {
      newConfig.path = pathsForCloud[id];
    }
    newConfig.database_type = id;
    updateConfig(newConfig);
  };
  return /* @__PURE__ */ React.createElement("fieldset", null, !isCloud && /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "path",
      name: "path",
      label: "File path",
      autoFocus: true,
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("path", "The path to the database file."),
      bsStyle: validationState("path"),
      value: config.path,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "database-type-select",
      label: "Database type",
      required: true,
      autoFocus: true,
      help: "Select the type of the database file",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        placeholder: "Select the type of database file",
        clearable: false,
        options: databaseTypes,
        onChange: onDbTypeSelect,
        value: config.database_type
      }
    )
  ), /* @__PURE__ */ React.createElement(
    TimeUnitInput,
    {
      label: "Refresh file",
      help: "If enabled, the database file is checked for modifications and refreshed when it changed on disk.",
      update: updateCheckInterval,
      value: config.check_interval,
      unit: config.check_interval_unit || "MINUTES",
      defaultEnabled: config.check_interval > 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ));
};
export default MaxmindAdapterFieldSet;
